<mat-form-field appearance="outline">
    <mat-label>{{ labelKey | translate }}</mat-label>
    <mat-select [value]="value" [placeholder]="labelKey | translate" (selectionChange)="onSelectChange($event)" [disabled]="isDisabled()" [required]="_isRequired()">
        @for (option of options; track options) {
            <mat-option [value]="option.value">{{ option.text }}</mat-option>
        }
    </mat-select>
</mat-form-field>
@if (showError()) {
    @for (msg of errorMessages(); track msg) {
        <mat-error>{{ msg }}</mat-error>
    }
}